import { Mutation } from 'react-apollo'
import requestPasswordLink, {
  RequestPasswordLink,
  RequestPasswordLinkInput
} from '../../graphql/mutations/requestPasswordLink'
import withMutation from './withMutation'

class RequestPasswordLinkMutation extends Mutation<
  RequestPasswordLink,
  RequestPasswordLinkInput
> {}

export default withMutation(requestPasswordLink)(RequestPasswordLinkMutation)



// WEBPACK FOOTER //
// ./src/components/mutations/RequestPasswordLinkMutation.tsx